<template>
  <div class="main">
    <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>公告管理</el-breadcrumb-item>
    <el-breadcrumb-item>添加公告</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card>
<el-button type="success" @click="insertAnnouncement">新增</el-button>

<el-table
    :data="announcement"
    border
    style="width: 100%">
    <el-table-column
      prop="content"
      label="标题"
      show-overflow-tooltip
      width="120">
    </el-table-column>
    <el-table-column
      prop="oldFileName"
      label="附件名称"
      show-overflow-tooltip
      width="150">
    </el-table-column>
    <el-table-column
      width="200"
      prop="htmpPath"
      show-overflow-tooltip
      label="网页状态">
    </el-table-column>
    <el-table-column
      label="是否显示" 
      width="110">
      <!-- 卡槽 -->
      <template slot-scope="scope">
<el-switch
  v-model="scope.row.isPublish" @change="AnnounShow(scope.row)">
</el-switch>
</template>
    </el-table-column>
    <el-table-column
      label="操作" 
      width="120">
      <!-- 卡槽 -->
      <template slot-scope="scope">
        <el-button  @click="deleteAnn(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
</template>
    </el-table-column>
  </el-table>




  </el-card>
  <el-dialog
  :visible.sync="insertDialog"
  width="50%"
  destroy-on-close
  v-loading.fullscreen.lock="loading">
  <el-form :model="insertForm" status-icon :rules="rulesInsert" ref="ruleInsert" label-width="100px" class="demo-ruleForm">
    <el-form-item label="标题：" prop="content">
    <el-input  v-model="insertForm.content"></el-input>
  </el-form-item>
  <el-form-item label="任务码：" prop="announcementCode">
    <el-input  v-model="insertForm.announcementCode"></el-input>
  </el-form-item>
</el-form>
<span>上传附件</span>
<el-upload
  class="upload-demo"
  drag
  action="https://jsonplaceholder.typicode.com/posts/"
  :auto-upload="false"
  :on-change="fileChange3"
   ref="uploadss"
  :on-remove="fileRemove3"
  accept=".html,.htm,.xlsx,.docx,.doc">
  <i class="el-icon-upload"></i>
  <div class="el-upload__text">将附件拖到此处，或<em>点击上传</em></div>
</el-upload>

<span>公告网页</span>
  <el-row>
  <el-col :span="12"><div class="grid-content bg-purple">
<el-upload
  class="upload-demo"
  drag
  action="https://jsonplaceholder.typicode.com/posts/"
  :auto-upload="false"
  :on-change="fileChange"
   ref="uploads"
  :on-remove="fileRemove"
  accept=".html,.htm">
  <i class="el-icon-upload"></i>
  <div class="el-upload__text">将html文件拖到此处，或<em>点击上传</em></div>
</el-upload>
  </div></el-col>
  <el-col :span="12"><div class="grid-content bg-purple-light">

<el-upload
  class="upload-demo"
  drag
  ref="upload"
  action="https://jsonplaceholder.typicode.com/posts/"
  :auto-upload="false"
  multiple="multiple"
  :show-file-list="false"
  :on-change="handleChanges"
  :on-remove="handleRemoves">
  <i class="el-icon-upload"></i>
  <div class="el-upload__text">将html文件样式文件拖到此处，或<em>点击上传</em></div>
   <div class="el-upload__tip" slot="tip">累计上传{{fileList5.length}}个文件</div>
</el-upload>
  </div></el-col>
</el-row>
  <div  class="subClass">
    <el-button  type="primary" @click="subInsertForm">提交</el-button>
       <el-button type="primary" @click="resetResult">重 置</el-button>
    <el-button @click="insertDialog = false">取 消</el-button>

  </div>
</el-dialog>
  </div>
</template>

<script>
export default {
  created(){
    this.selectAnnouncement()
  },
data(){
    return{
      announcement:[],
        insertDialog:false,
        loading:false,
        insertForm:{
            content:'',
            announcementCode:'',
        },
        rulesInsert:{
          announcementCode:[
            { required: true, message: '请输入任务码', trigger: 'blur' },
          ],content:[
            { required: true, message: '请输入标题', trigger: 'blur' },
          ],
        },
        fileList5: [],
       fileList6:[],
       fileList3:[],
       fileList4:[],
       fileList7:[],
       fileList8:[],
    }
},
methods:{selectAnnouncement(){
  this.axios.post("/announcement/selectAnnouncement")
         .then(resp => { 
                       if(resp.data.status == 1) {
                        console.log(resp.data.result)
                                this.announcement=resp.data.result
                                }else {
                               
                                       alert("出错")                          
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
},AnnounShow(data){
console.log(data)
  this.axios.post("/announcement/updateAnnouncement","announcementId="+data.announcementId+"&isPublish="+data.isPublish)
          .then(resp => { 
                      if(resp.data.status == 1) {                                                                                        
                                    console.log(resp.data.result)                      
                                                  
                                }else {
                                   alert("拿取数据失败")                             
                                       
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 

},
    insertAnnouncement(){
        this.insertDialog=true
    },subInsertForm(){
      this.$refs.ruleInsert.validate((resp)=>{
        if(!resp)
        return
        this.loading=true
        if(this.fileList5.length <= 0 ||this.fileList3.length==0 ||this.fileList7.length==0){
           this.$message.error("请选择上传文件") 
         return false}
    for(var i=0;i<this.fileList5.length;i++){
     this.fileList6.push(this.fileList5[i].raw)
    }
    this.fileList4=this.fileList3[0].raw
    this.fileList8=this.fileList7[0].raw

     let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      const fd = new FormData();
       this.fileList6.forEach((file) => {
         fd.append("style", file);
      });
      fd.append("FuJian",this.fileList8)
       fd.append("content",this.insertForm.content)
       fd.append("announcementCode",this.insertForm.announcementCode)
      fd.append("file",this.fileList4)
        this.axios.post("/announcement/insertAnnouncement",fd,config)
         .then(resp => { 
          this.loading=false
                       if(resp.data.status == 1) {
                                  this.$message.success("添加成功")
                                 this.resetResult()
                                 this.selectAnnouncement()
                                   this.insertDialog=false    
                                }else {
                                  this.$message.error(resp.data.message)
                                  this.fileList6=[],
                                  this.fileList4=[],
                                       alert("出错")                          
                                }
                            })
                            .catch((err) => {
                              this.loading=false
                                alert("出错了")
                                console.log(err)
                            }) 

      })
        
    },handleChanges(file, fileList) {
      this.fileList5=fileList
      },handleRemoves(file, fileList) {
        this.fileList5=fileList
      },fileChange(file, fileList){
        this.fileList3=fileList
      },fileRemove(file, fileList){
        this.fileList3=fileList
      },fileChange3(file, fileList){
        this.fileList7=fileList
      },fileRemove3(file, fileList){
        this.fileList7=fileList
      },resetResult(){
        this.insertForm.content=''
         this.fileList5=[]
                                  this.fileList6=[]
                                  this.fileList3=[]
                                  this.fileList4=[]
                                  this.fileList7=[]
                                  this.fileList8=[]
                                  this.$refs.upload.clearFiles()
                                  this.$refs.uploads.clearFiles()
                                  this.$refs.uploadss.clearFiles()

      },deleteAnn(data){
        console.log(data)
        this.axios.post("/announcement/deleteAnn","announcementId="+data.announcementId)
          .then(resp => { 
                      if(resp.data.status == 1) {                                                                                        
                                    console.log(resp.data.result)                      
                                                  this.$message.success("删除成功")
                                                  this.selectAnnouncement()
                                }else {
                                   alert("拿取数据失败")                             
                                       
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
      }
},
}
</script>

<style>
.main{
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/work/bam/Announcement.vue